export enum PayrollGroupModalTypes {
    OPEN_PAYROLLGROUP_MODAL = '[auth] OPEN_PAYROLLGROUP_MODAL',
    CLOSE_PAYROLLGROUP_MODAL = '[auth] CLOSE_PAYROLLGROUP_MODAL',
    REACTIVE_PAYROLLGROUP_COL = '[auth] REACTIVE_PAYROLLGROUP_COL',
    UPDATE_PAYROLLGROUPS ='[auth] UPDATE_PAYROLLGROUPS',
    OPEN_PAYROLLGROUP_CREATE_MODAL = '[auth] OPEN_PAYROLLGROUP_CREATE_MODAL'
}